// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ralts: PokeData = {
  "id": 280,
  "name": "ralts",
  "height": 4,
  "weight": 66,
  "base_experience": 40,
  "types": [
    PokeType.PSYCHIC,
    PokeType.FAIRY
  ],
  "api_moves": [
    "growl",
    "psybeam",
    "confusion",
    "psychic",
    "hypnosis",
    "teleport",
    "double-team",
    "dream-eater",
    "charm",
    "future-sight",
    "imprison",
    "magical-leaf",
    "calm-mind",
    "lucky-chant",
    "stored-power",
    "heal-pulse",
    "disarming-voice",
    "draining-kiss",
    "life-dew"
  ],
  "moves": [
    "growl",
    "psychic",
    "future-sight",
    "calm-mind",
    "life-dew",
    "play-rough",
    "hyper-voice",
    "moonblast",
    "prismatic-cage",
    "reflect",
    "kinesis",
    "psy-pulse",
    "psychic-fangs"
  ],
  "evolution_chain": {
    "id": 140,
    "item": null,
    "species": [
      {
        "name": "ralts",
        "order": 305,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kirlia",
        "order": 306,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 280,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "gardevoir",
        "order": 307,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 281,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "gallade",
        "order": 308,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 281,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "dawn-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": {
              "name": "male"
            }
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 29,
    "speed": 40,
    "ability_power": 45
  },
  "stat_changes": [],
  "catch_rate": 235,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
